//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalIcon from '@tidal/styles-icons/src/components/tidal-icon.vue';
import { generalArrowDown, generalRightArrow } from '@tidal/styles-icons/src/icons';

/**
 * @typedef {{
 *   name: string
 *   value?: string
 *   subtitle?: string
 *   href?: string
 *   callback?: () => void
 *   external?: boolean
 * }} DropdownItem
 */

export default {
    components: {
        tidalIcon,
    },
    props: {
        /**
         * @property {string} items[].name
         * @property {string} [items[].value]
         * @property {string} [items[].subtitle]
         * @property {string} [items[].href]
         * @property {function} [items[].callback]
         * @property {boolean} [items[].external=false]
         * @type {import('vue').PropOptions<DropdownItem[]>}
         */
        items: {
            type: Array,
            required: true,
        },
        active: {
            type: [String, Number, Boolean, Object, Array],  // to allow "any" type
            default: undefined,
        },
        buttonClass: {
            type: String,
            default: null,
        },
        dropdownClass: {
            type: String,
            default: null,
        },
        ariaLabel: {
            type: String,
            default: null,
        },
        animation: {
            type: Boolean,
            default: true,
        },
        indicator: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        reversed: {
            type: Boolean,
            default: false,
        },
        alignRight: {
            type: Boolean,
            default: false,
        },
        closeOnClick: {
            type: [String, Boolean],
            default: 'auto',
            validator(value) {
                return value === true || value === false || value === 'auto';
            },
        },
    },
    data() {
        return {
            showDropDown: false,
            /** @type {HTMLElement | false | null} */
            mobileElement: null,
        };
    },
    computed: {
        dropdownID() {
            let hash = 0;

            const itemsString = JSON.stringify(this.items);
            const nameLength = itemsString.length;

            for (let i = 0; i < nameLength; i++) {
                hash = ((hash << 5) - hash) + itemsString.charCodeAt(i);
                hash |= 0; // Convert to 32bit integer
            }

            return `dropdown-${hash}`;
        },
        /** @return {Record<'generalArrowDown' | 'generalRightArrow', string>} */
        icons() {
            return {
                generalArrowDown,
                generalRightArrow,
            };
        },
    },
    beforeDestroy() {
        this.removeDropdownListener();
    },
    methods: {
        /**
         * @param {UIEvent} event
         * @param {DropdownItem} item
         */
        click(event, item) {
            this.$emit('click', item.value, event);

            if (this.closeOnClick === true || (this.closeOnClick === 'auto' && !item.href)) {
                this.showDropDown = false;
                this.removeDropdownListener();
            }

            if (item.callback instanceof Function) {
                item.callback();
            }
        },
        /** @param {boolean} [noFocus] */
        toggleDropDown(noFocus) {
            if (this.disabled) {
                return;
            }

            this.showDropDown = !this.showDropDown;

            if (this.showDropDown) {
                this.addDropdownListener();
            } else {
                this.removeDropdownListener(noFocus);
            }
        },
        /** @param {UIEvent} e */
        dropdownListener(e) {
            const dropdownElement = /** @type {HTMLElement} */(this.$refs.dropdown);
            if (!dropdownElement.contains(/** @type {Node | null} */(e.target))) {
                this.toggleDropDown(true);
            }
        },
        addDropdownListener() {
            document.addEventListener('click', this.dropdownListener);
            document.addEventListener('keydown', this.keydownListener);
            if (this.mobileElement === null) {
                this.mobileElement = navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? document.getElementsByTagName('html')[0] : false;
            }
            if (this.mobileElement) {
                this.mobileElement.style.cursor = 'pointer';
                this.mobileElement.style.webkitTapHighlightColor = 'rgba(0, 0, 0, 0)';
            }
        },
        /** @param {boolean} [noFocus] */
        removeDropdownListener(noFocus) {
            document.removeEventListener('click', this.dropdownListener);
            document.removeEventListener('keydown', this.keydownListener);
            if (this.mobileElement) {
                this.mobileElement.style.cursor = '';
                this.mobileElement.style.webkitTapHighlightColor = '';
            }
            if (!noFocus) {
                const dropdownElement = /** @type {HTMLElement} */(this.$refs.dropdown);
                const buttonElement = /** @type {HTMLButtonElement} */(dropdownElement.querySelector('.tidal-dropdown-button'));
                buttonElement && buttonElement.focus();
            }
        },
        /** @param {KeyboardEvent} e */
        keydownListener(e) {
            const keyEsc = e.keyCode === 27;
            const keyUp = e.keyCode === 38;
            const keyDown = e.keyCode === 40;

            if (!keyEsc && !keyUp && !keyDown) {
                return;
            }

            const dropdownElement = /** @type {HTMLElement} */(this.$refs.dropdown);
            if (!dropdownElement.querySelector(':focus')) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            if (keyEsc) {
                return this.toggleDropDown();
            }

            const active = dropdownElement.querySelector('.tidal-dropdown-menu--link:focus');
            if (active) {
                const parentElement = active.parentElement;
                if (parentElement) {
                    const next = keyDown ? parentElement.nextElementSibling : parentElement.previousElementSibling;
                    if (next) {
                        const nextElement = /** @type {HTMLAnchorElement} */(next.querySelector('.tidal-dropdown-menu--link'));
                        nextElement && nextElement.focus();
                    }
                }
            } else {
                if (keyDown) {
                    const linkElement = /** @type {HTMLAnchorElement} */(dropdownElement.querySelector('.tidal-dropdown-menu--link'));
                    linkElement && linkElement.focus();
                } else {
                    const links = /** @type {NodeListOf<HTMLAnchorElement>} */(dropdownElement.querySelectorAll('.tidal-dropdown-menu--link'));
                    links[links.length - 1].focus();
                }
            }
        },
    },
};
